import { accountActions } from './accountActions';
import { appPhuHuynhActionsWrapper } from './app-phuhuynh/appPhuHuynhActionsWrapper';
import { baiTapActions } from './bai-tap/baiTapAction';
import { baiTapKetQuaActions } from './bai-tap/baiTapKetQuaAction';
import { baiTapKetQuaLopActions } from './bai-tap/baiTapKetQuaLopActions';
import { baiTapTypeActions } from './bai-tap/baiTapTypeActions';
import { baiVietActions } from './bai-viet/baiVietActions';
import { baiVietDetailActions } from './bai-viet/baiVietDetailActions';
import { baiVietTrangThaiActions } from './bai-viet/baiVietTrangThaiActions';
import { baoCaoTienBoActions } from './bao-cao-tien-bo/baoCaoTienBoActions';
import { categorySourceActions } from './categorySourceActions';
import { appConfigAction } from './common/appConfigAction';
import { commonActions } from './commonActions';
import { dgdkHocTapActions } from './danh-gia/dinh-ky/dgdkHocTapActions';
import { dgdkNlpcActions } from './danh-gia/dinh-ky/dgdkNlpcActions';
import { dgtxKetQuaActions } from './danh-gia/thuong-xuyen/dgtxKetQuaActions';
import { dgtxKetQuaMonHocActions } from './danh-gia/thuong-xuyen/dgtxKetQuaMonHocActions';
import { danhMucActionsWrapper } from './danh-muc/danhMucActionsWrapper';
import { giaoVienActions } from './danh-muc/giaoVienAction';
import { monHocActions } from './danh-muc/monHocAction';
import { toKhoiActions } from './danh-muc/toKhoiAction';
import { dictionaryActions } from './dictionaryAction';
import { diemDanhActions } from './diem-danh/diemDanhActions';
import { diemDanhStatusActions } from './diem-danh/diemDanhStatusActions';
import { giaoVienNhanXetActions } from './giaoVienNhanXetActions';
import { hocSinhActionsWrapper } from './hoc-sinh/hocSinhActionsWrapper';
import { lopBoMonActionWrapper } from './lop-bo-mon/lopBoMonActionWrapper';
import { lopChuNhiemActions } from './lop-chu-nhiem/lopChuNhiemActions';
import { lopHanhChinhSoDiemActions } from './lop-hanh-chinh/lopHanhChinhSoDiemActions';
import { lopMonHocActions } from './lop-mon-hoc/lopMonHocActions';
import { nhanXetHangNgayActions } from './nhan-xet/nhanXetHangNgayActions';
import { thaiDoHocTapActions } from './nhan-xet/thaiDoHocTapActions';
import { thaiDoHocTapTieuChiActions } from './nhan-xet/thaiDoHocTapTieuChiActions';
import { nhapDiemActions } from './nhap-diem/nhapDiemActions';
import { notifyActions } from './notify/notifyAction';
import { loaiPhongActions } from './phong-hoc/loaiPhongActions';
import { phongHocActions } from './phong-hoc/phongHocActions';
import { soNhanXetItemActions } from './so-diem-tieu-hoc/dgdkDmPhamChatActions';
import { dgtxDmHocTapActions } from './so-diem-tieu-hoc/dgtxDmHocTapActions';
import { dgtxDmPhamChatActions } from './so-diem-tieu-hoc/dgtxDmPhamChatActions';
import { dgdkDmNlpcSetActions } from './so-diem-tieu-hoc/dinh-ky/dgdkDmNlpcSetActions';
import { soDiemActionsWrapper } from './so-diem/soDiemActionsWrapper';
import { thoiKhoaBieuActionsWrapper } from './thoi_khoa-bieu/thoiKhoaBieuActionsWrapper';
import { uploadActions } from './upload-file/uploadActions';
import { xepHangHocSinhActions } from './xep-hang-hoc-sinh/xepHangHocSinhActions';

import { baiVietCommentActions } from './bai-viet-comment/baiVietCommentActions';
import { chamTietActions } from './cham-tiet/chamTietActions';
import { chamTietLoaiTietActions } from './cham-tiet/chamTietLoaiTietActions';
import { ychtGroupActions } from './danh-muc/ychtGroupActions';
import { diemVanMinhKetQuaActions } from './diemvanminh-ketqua/diemVanMinhKetQuaActions';
import { DiemVanMinhTieuChiActions } from './diemvanminh-tieuchi/diemVanMinhTieuChiActions';
import { tongHopDinhKyActions } from './tong-hop/tongHopDinhKyActions';
import { gioCongDongActions } from './gio-cong-dong/gioCongDongAction';
import { gioCongDongHoatDongAction } from './gio-cong-dong/gioCongDongHoatDongAction';
import { cuocThaoLuanAction } from './cuoc-thao-luan/cuocThaoLuanAction';
import { theoDoiRCActions } from './theo-doi-rc/theoDoiRCActions';
import { legalGroupActions } from './legal-document/legalGroupActions';
import { legalDocumentActions } from './legal-document/legalDocumentActions';
import { chieuCaoCanNangActionts } from './dan-thuoc/chieuCaoCanNangActions';
import { dgTuanKetQuaActions } from './danh-gia/tuan/dgTuanKetQuaActions';
import { hoatDongHangNgayActions } from './danh-gia/hoatDongHangNgayActions';
import { dotDanhGiaActions } from './danh-gia/dotDanhGiaActions';
import { danhGiaKetQuaActions } from './danh-gia/danhGiaKetQuaActions';
import { dotDanhGiaLopActions } from './danh-gia/dotDanhGiaLopActions';

export const actions = {
    account: accountActions,
    appConfig: appConfigAction,
    appPhuHuynhWrapper: appPhuHuynhActionsWrapper,
    categorySource: categorySourceActions,
    common: commonActions,
    dictionary: dictionaryActions,
    monHoc: monHocActions,
    ychtGroupActions,
    lopBoMonWrapper: lopBoMonActionWrapper,
    hocSinh: hocSinhActionsWrapper,
    soDiem: soDiemActionsWrapper,
    toKhoi: toKhoiActions,
    giaoVien: giaoVienActions,
    dgtxDmHocTap: dgtxDmHocTapActions,
    dgtxDmPhamChat: dgtxDmPhamChatActions,
    soNhanXetItem: soNhanXetItemActions,
    dgdkDmNlpcSetAction: dgdkDmNlpcSetActions,
    giaoVienNhanXet: giaoVienNhanXetActions,
    loaiPhong: loaiPhongActions,
    phongHoc: phongHocActions,
    thoiKhoaBieuWrapper: thoiKhoaBieuActionsWrapper,
    danhMucWrapper: danhMucActionsWrapper,
    uploadFile: uploadActions,
    baiViet: baiVietActions,
    baiVietTrangThai: baiVietTrangThaiActions,
    baiVietDetail: baiVietDetailActions,
    notify: notifyActions,
    diemDanh: diemDanhActions,
    diemDanhStatus: diemDanhStatusActions,
    nhanXetHangNgay: nhanXetHangNgayActions,
    baiTapWrapper: {
        type: baiTapTypeActions,
        baiTap: baiTapActions,
        baiTapKetQua: baiTapKetQuaActions,
        baiTapKetQuaLop: baiTapKetQuaLopActions
    },
    nhapDiem: nhapDiemActions,
    lopChuNhiem: lopChuNhiemActions,
    thaiDoHocTapWrapper: {
        thaiDoHocTap: thaiDoHocTapActions,
        thaiDoHocTapTieuChi: thaiDoHocTapTieuChiActions
    },
    diemVanMinhKetQua: diemVanMinhKetQuaActions,
    diemVanMinhTieuChi: DiemVanMinhTieuChiActions,
    danhGia: {
        dinhKy: {
            nlpc: dgdkNlpcActions,
            hocTap: dgdkHocTapActions
        },
        thuongXuyen: {
            nlpc: dgtxKetQuaActions,
            hocTap: dgtxKetQuaMonHocActions
        },
        tuan: dgTuanKetQuaActions,
        hoatDongHangNgay:hoatDongHangNgayActions,
        dotDanhGiaActions,
        danhGiaKetQuaActions,
        dotDanhGiaLopActions
    },
    lopHanhChinhSoDiem: lopHanhChinhSoDiemActions,
    baoCaoTienBo: baoCaoTienBoActions,
    xepHangHocSinh: xepHangHocSinhActions,
    lopMonHoc: lopMonHocActions,
    tongHop: {
        dinhKy: tongHopDinhKyActions
    },
    baiVietComment: baiVietCommentActions,
    chamTiet: chamTietActions,
    chamTietLoaiTiet: chamTietLoaiTietActions,
    gioCongDongWrapper: {
        gioCongDong: gioCongDongActions,
        hoatDong: gioCongDongHoatDongAction
    },
    cuocThaoLuan: cuocThaoLuanAction,
    theoDoiRCActions,
    legalDocument: {
        group: legalGroupActions,
        document: legalDocumentActions
    },
    danThuoc: {
        chieuCaoCanNangActionts
    }
}
